/* loaded by smart-asset */
export default require("./assets/red-pallet-loaded.i.svg")